import React from 'react'
import { Link } from 'gatsby'
import { color, fontFamily, fontWeight, space, themeGet } from 'styled-system'
import styled from '@emotion/styled'

export const TitleLink = styled(Link)(
  {
    textDecoration: `none`,
  },
  props => ({
    color: themeGet('colors.black.900')(props),
    fontSize: themeGet('fontSizes.4')(props),
    fontWeight: themeGet('fontWeights.1')(props),
  })
)

const NavLink = styled(TitleLink)(
  color,
  fontWeight,
  fontFamily,
  space,
  props => ({
    color: props.color,
  })
)

NavLink.propTypes = {
  ...color.propTypes,
  ...fontWeight.propTypes,
  ...fontFamily.propTypes,
  ...space.propTypes,
}

NavLink.defaultProps = {
  color: 'grey.500',
  fontFamily: 'brand',
  fontWeight: 400,
  mr: 3,
}

export const NavItem = props => (
  <NavLink
    getProps={({ isCurrent }) => {
      return isCurrent ? { style: { color: 'black' } } : false
    }}
    {...props}
  />
)
